import type { DroneState } from "@/types/fleet";
import { Badge, Card, Flex, Text } from "@chakra-ui/react";
import {
  Battery,
  Wifi,
  Navigation,
  Gauge,
} from "lucide-react";

interface DronePopupProps {
  drone: DroneState;
}

export function DronePopup({ drone }: DronePopupProps) {
  const { telemetry } = drone;

  const batteryColor =
    telemetry?.battery?.percentage && telemetry.battery.percentage < 20
      ? "red"
      : telemetry?.battery?.percentage && telemetry.battery.percentage < 50
        ? "orange"
        : "green";

  const signalStrength = telemetry?.signal?.strength !== undefined
    ? telemetry.signal.strength > 75
      ? "Excellent"
      : telemetry.signal.strength > 50
        ? "Good"
        : telemetry.signal.strength > 25
          ? "Fair"
          : "Poor"
    : "Unknown";

  return (
    <Card.Root minW="200px" pointerEvents="auto" shadow="lg" bg="bg.subtle">
      <Card.Body p="3">
        <Flex align="center" justify="space-between" mb="2">
          <Text fontWeight="semibold" fontSize="sm">{drone.name}</Text>
          <Badge colorPalette={drone.connected ? "green" : "red"}>
            {drone.connected ? "Online" : "Offline"}
          </Badge>
        </Flex>

        <Flex direction="column" gap="1.5" fontSize="xs" color="fg.muted">
          {telemetry?.battery && (
            <Flex align="center" gap="2">
              <Battery style={{ height: 12, width: 12 }} />
              <Text>Battery:</Text>
              <Badge colorPalette={batteryColor} size="sm">
                {telemetry.battery.percentage.toFixed(0)}%
              </Badge>
            </Flex>
          )}

          {telemetry?.position && (
            <Flex align="center" gap="2">
              <Navigation style={{ height: 12, width: 12 }} />
              <Text>Altitude: {telemetry.position.altitude.toFixed(1)}m</Text>
            </Flex>
          )}

          {telemetry?.signal && (
            <Flex align="center" gap="2">
              <Wifi style={{ height: 12, width: 12 }} />
              <Text>Signal: {signalStrength}</Text>
            </Flex>
          )}

          {telemetry?.custom?.speed !== undefined && (
            <Flex align="center" gap="2">
              <Gauge style={{ height: 12, width: 12 }} />
              <Text>Speed: {(telemetry.custom.speed as number).toFixed(1)} m/s</Text>
            </Flex>
          )}
        </Flex>
      </Card.Body>
    </Card.Root>
  );
}
